import type { MomentInput } from 'moment'
import moment from 'moment'

/**
 * Given 2 dates as args, check if both dates are the same day
 */
export const isSameDay = (dateA: MomentInput, dateB: MomentInput) => {
  return moment(dateA).isSame(dateB, 'day')
}
